import { Box, Typography } from "@mui/material";

export function DataRow({ label, children }) {
  return (
    <Box>
      <Typography variant="body2" color="text.secondary" component="div">
        {label}
      </Typography>
      <Typography
        variant="body2"
        component="div"
        sx={{ fontWeight: 600, mt: 0.5 }}
      >
        {children}
      </Typography>
    </Box>
  );
}

// Same frame and header band as DataTable's card, so detail cards line up
// with the tables on the page.
export function Card({ title, children }) {
  return (
    <Box
      component="section"
      aria-label={title}
      sx={(theme) => ({
        border: `1px solid ${theme.palette.grey[200]}`,
        borderRadius: theme.spacing(1),
        backgroundColor: "background.paper",
        overflow: "hidden",
      })}
    >
      <Box
        sx={{
          backgroundColor: "card.headerBackground",
          borderBottom: 1,
          borderColor: "grey.200",
          px: { xs: 2, md: 4 },
          py: { xs: 1, md: 2.5 },
        }}
      >
        <Typography
          variant="h6"
          component="h2"
          sx={{ fontWeight: 600, lineHeight: 1.5 }}
        >
          {title}
        </Typography>
      </Box>
      {children}
    </Box>
  );
}
